<template>
  <OptionsField
    :options="options"
    :validation-rules="{
      acceptPrivacy: validateAcceptPrivacy,
      acceptAll: validateAcceptAll,
    }"
    :validation-messages="{
      acceptPrivacy: 'Bitte stimme der Datenschutzerklärung zu',
      acceptAll: 'Bitte stimme der Datenverarbeitung zu',
    }"
    validation="acceptPrivacy"
    name="consent"
    multiple
    spaceless
    centered
  />
</template>

<script>
import { isArray } from 'lodash-es';

export default {
  name: 'ConsentField',
  props: {
    hideExtendedPrivacy: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    options() {
      const options = {
        privacy: `Ich habe die <a href='https://www.rewe-lieferservice.jobs/datenschutz' target='_blank'>Datenschutzerklärung</a> gelesen und akzeptiert.*`,
      };

      if (!this.hideExtendedPrivacy) {
        options.extendedPrivacy = `Ich stimme der erweiterten Nutzung meiner Bewerbungsdaten zu<br/><span class='form-text text-muted' style="font-size: 0.8em;">Mit Deiner Zustimmung dürfen wir Dir eine alternative Stelle in einem Unternehmen der REWE Group anbieten und Dich diesbezüglich kontaktieren. Diese Zustimmung kann jederzeit widerrufen werden. Mehr Informationen findest Du in unseren <a target='_blank' href='https://www.rewe-lieferservice.jobs/datenschutz' tabindex='0'>Datenschutzhinweisen</a></span>`;
      }

      return options;
    },
    optionsCount() {
      return Object.keys(this.options).length;
    },
  },
  methods: {
    validateAcceptAll({ value }) {
      return isArray(value) ? value.length === this.optionsCount : false;
    },
    validateAcceptPrivacy({ value }) {
      return isArray(value) && value.includes('privacy');
    },
  },
};
</script>
